var $nav = {
  // ======================================================================
  // VARS
  // ======================================================================

  visible: false,
  timeout1: null,
  timeOpen: 750,
  timeWipe: 750 * 1.5,

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    $el('body').addClass('js-nav-closed');
    $('body').on('click', '.nav__btn', function() {
      $nav.toggle();
      return false;
    });
  },

  // ======================================================================
  // TOGGLE
  // ======================================================================

  toggle: function() {
    if (!$nav.visible) {
      $nav.show();
    } else {
      $nav.hide();
    }
  },

  show: function() {
    clearTimeout($nav.timeout1);
    // show page blocker
    $utils.blocker.show();
    // show nav blocker
    $el('#nav-blocker').show();
    // scroll nav overflow to top (just in case)
    $el('.nav__scroll').scrollTop(0);
    // scroll nav bar to edge of page (in case on landing page and haven't scrolled yet)
    $scroll.scrollToNav(function() {
      // nav color class
      if ($el('body').hasClass('js-page-invert')) {
        $el('body').addClass('js-nav-invert');
      } else {
        $el('body').removeClass('js-nav-invert');
      }
      // show nav
      $el('body')
        .removeClass('js-nav-closed')
        .addClass('js-nav-open');
      // timeout whilst nav hides
      $nav.timeout1 = setTimeout(function() {
        // hide page blocker
        $utils.blocker.hide();
      }, $nav.timeOpen);
    });
    // save state
    $nav.visible = true;
  },

  hide: function(instant, hidePageBlocker) {
    clearTimeout($nav.timeout1);
    // show page blocker
    $utils.blocker.show();
    // hide nav blocker
    $el('#nav-blocker').hide();
    // hide nav
    $el('body')
      .removeClass('js-nav-open')
      .addClass('js-nav-closed');
    // timeout whilst nav hides
    $nav.timeout1 = setTimeout(
      function() {
        // hide page blocker
        if (hidePageBlocker !== false) {
          $utils.blocker.hide();
        }
        // save state
        $nav.visible = false;
      },
      instant || !$nav.visible ? 0 : $nav.timeOpen
    );
  },

  // ======================================================================
  // WIPE - PAGE TRANSITION
  // ======================================================================

  wipeRight: function() {
    $el('body').addClass('js-nav-wipe1');
  },

  wipeLeft: function() {
    if ($windowsize.isDesktop) {
      $el('body').addClass('js-nav-wipe3');
      var t1 = new gsap.timeline();
      t1.fromTo(
        $('.page--current'),
        $nav.timeWipe / 1000,
        {
          x: '100vw'
        },
        {
          x: 0,
          ease: Power1.easeInOut
        },
        0
      );
      t1.to(
        $el('.nav__wipe, .nav__wrap, .nav__open'),
        $nav.timeWipe / 1000,
        {
          width: 0,
          ease: Power1.easeInOut
        },
        0
      );
      t1.add(function() {
        $nav.wipeEnd();
      }, $nav.timeWipe / 1000);
    } else {
      $el('body').addClass('js-nav-wipe2');
    }
  },

  wipeEnd: function() {
    $nav.hide(true);
    $el('body').removeClass('js-nav-wipe1 js-nav-wipe2 js-nav-wipe3');
    $el('.nav__wipe, .nav__wrap, .nav__open').css({
      width: ''
    });
  }
};
